import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";

function FeatureBanner() {
  const [isMobile, setIsMobile] = useState(false);
  const [isTab, setIsTab] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768);
      setIsTab(width > 768 && width <= 1024);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Responsive styles
  const bannerStyle = {
    backgroundImage: "linear-gradient(98.24deg, #6CD5F7 0%, #FEE2CE 35.94%, #B0A9DF 69.27%, #5B6AF0 100%)",
    padding: isMobile ? "40px 20px" : (isTab ? "60px 50px" : "80px 110px"),
    height: "auto"
  };

  const titleStyle = {
    fontSize: isMobile ? "24px" : (isTab ? "30px" : "36px"),
    fontWeight: "bold",
    lineHeight: isMobile ? "32px" : (isTab ? "40px" : "48px"),
    marginBottom: isMobile ? "10px" : "0"
  };

  const paragraphStyle = {
    fontSize: "16px",
    color: "rgb(75 85 99)",
    lineHeight: "24px",
    marginBottom: isMobile ? "20px" : "0"
  };

  const rowStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: isMobile ? "20px" : "40px",
    flexWrap: "wrap",
    gap: "10px"
  };

  const rowStyle2 = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: isMobile ? "10px" : "20px",
    flexWrap: "wrap",
    gap: "10px"
  };

  const itemStyle = {
    fontSize: "16px",
    fontWeight: "bold",
    lineHeight: "24px",
    padding: isMobile ? "8px 12px" : "12px 16px",
    color: "rgb(75 85 99)",
    backgroundColor: "#fff",
    borderRadius: "30px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap"
  };

  const dotStyle = {
    marginRight: "8px",
    width: isMobile ? "8px" : "12px",
    height: isMobile ? "8px" : "12px",
    backgroundImage: "linear-gradient(90deg, rgba(108, 213, 246, 1) 0%, rgba(248, 157, 92, 1) 50%, rgba(91, 106, 240, 1) 100%)",
    borderRadius: "50%",
    flexShrink: 0
  };

  return (
    <div style={bannerStyle}>
      <Col span={24} style={{ textAlign: "center" }}>
        <h2 style={titleStyle}>
          Features That Will Skyrocket Your {!isMobile && <br />} Business Growth and Profits!
        </h2>
        <p style={paragraphStyle}>
          Features That Will Skyrocket Your Business Growth and Profits!
        </p>

        <Row style={rowStyle}>
          {[
            "Accounting Management",
            "Billing Management",
            "Users",
            "Product Management",
            "Stock Management",
            "POS",
          ].map((text) => (
            <Col key={text}>
              <div style={itemStyle}>
                <div style={dotStyle}></div>
                <p style={{ margin: 0 }}>{text}</p>
              </div>
            </Col>
          ))}
        </Row>

        <Row style={rowStyle2}>
          {[
            "Online Stores",
            "Multiple Warehouses",
            "Roles",
            "Invoices",
            "Online Orders",
          ].map((text) => (
            <Col key={text}>
              <div style={itemStyle}>
                <div style={dotStyle}></div>
                <p style={{ margin: 0 }}>{text}</p>
              </div>
            </Col>
          ))}
        </Row>

        <Row style={rowStyle2}>
          {[
            "Customers",
            "Suppliers",
            "Retailers",
          ].map((text) => (
            <Col key={text}>
              <div style={itemStyle}>
                <div style={dotStyle}></div>
                <p style={{ margin: 0 }}>{text}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
    </div>
  )
}

export default FeatureBanner;